"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationMenuHeader = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('NavigationMenuHeader'), recompose_1.pure);
exports.NavigationMenuHeader = enhance(function (_a) {
    var className = _a.className, backgroundImage = _a.backgroundImage, name = _a.name, email = _a.email, image = _a.image;
    return (React.createElement("div", { className: classNames('sok-navigation-menu-header', className) },
        React.createElement("div", { className: "banner", style: { backgroundImage: "url(".concat(backgroundImage, ")") } }),
        React.createElement("img", { className: "avatar", src: image }),
        React.createElement("div", { className: "user-info" },
            React.createElement("div", { className: "name" },
                React.createElement("b", null, name)),
            React.createElement("div", { className: "email" }, email))));
});
//# sourceMappingURL=index.js.map